import Subject from './subject';
import { ISubject } from './iSubject';

export type { ISubject };
export default Subject;
